import { useFeatureFlags } from '@/components/FeatureFlagsContext';
import { useSeekerState } from '@/components/AppState';
import { CLIENT_FEATURE_FLAGS } from '@/constants';
import { ServiceIdsForSeniorMember } from '@/types/seeker';

export function useAdultCare() {
  const { czenServiceIdForMember } = useSeekerState();
  const featureFlags = useFeatureFlags();
  const isEligibleForAdultCareFlow = czenServiceIdForMember === ServiceIdsForSeniorMember.AdultCare;
  const adultCareFlagValue =
    featureFlags?.flags[CLIENT_FEATURE_FLAGS.GROWTH_SC_SKIP_INDEX_FOR_ADULT_CARE_SEM_LINKS]?.value;

  const isAdultCareFlow = adultCareFlagValue && isEligibleForAdultCareFlow;

  return {
    isAdultCareFlow,
  };
}
